// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../../node_modules/css-loader/dist/runtime/api.js";
import ___CSS_LOADER_AT_RULE_IMPORT_0___ from "-!../../../../node_modules/css-loader/dist/cjs.js!../../../css/App.css";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
___CSS_LOADER_EXPORT___.i(___CSS_LOADER_AT_RULE_IMPORT_0___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.privacy-policy {
    display: flex;
    justify-content: center;
    padding: 2rem 1.5rem;   
}

.privacy-policy__container {
    max-width: 800px;
    width: 100%;
    background-color: #ffffff;
    border-radius: 12px;
    padding: 2.5rem 2rem;
    box-shadow: 0 8px 24px rgba(0, 0, 0, 0.06);
}

.privacy-policy__title {
    font-size: 2rem;
    margin-bottom: 0.25rem;
}

.privacy-policy__last-updated {
    font-size: 0.9rem;
    color: #666666;
    margin-bottom: 1.5rem;
}

.privacy-policy__section {
    margin-bottom: 1.75rem;
}

    .privacy-policy__section h2 {
        font-size: 1.25rem;
        margin-bottom: 0.75rem;
    }

    .privacy-policy__section h3 {
        font-size: 1.05rem;
        margin-top: 1rem;
        margin-bottom: 0.5rem;
    }

    .privacy-policy__section p {
        line-height: 1.6;
        margin-bottom: 0.5rem;
    }

    .privacy-policy__section ul {
        margin: 0.5rem 0 0.75rem 1.25rem;
        padding: 0;
    }

    .privacy-policy__section li {
        margin-bottom: 0.35rem;
        line-height: 1.5;
    }

    .privacy-policy__section a {
        color: #0b63ce;
        text-decoration: none;
    }

        .privacy-policy__section a:hover,
        .privacy-policy__section a:focus {
            text-decoration: underline;
        }

.privacy-policy__disclaimer {
    font-size: 0.85rem;
    color: #777777;
    border-top: 1px solid #eeeeee;
    padding-top: 1rem;
    margin-top: 1.5rem;
}

/* Responsive tweaks */

@media (max-width: 600px) {
    .privacy-policy {
        padding: 1.5rem 1rem;
    }

    .privacy-policy__container {
        padding: 1.75rem 1.25rem;
        border-radius: 10px;
    }

    .privacy-policy__title {
        font-size: 1.6rem;
    }
}
`, "",{"version":3,"sources":["webpack://./src/assets/Documents/css/PrivacyPolicy.css"],"names":[],"mappings":"AAEA;IACI,aAAa;IACb,uBAAuB;IACvB,oBAAoB;AACxB;;AAEA;IACI,gBAAgB;IAChB,WAAW;IACX,yBAAyB;IACzB,mBAAmB;IACnB,oBAAoB;IACpB,0CAA0C;AAC9C;;AAEA;IACI,eAAe;IACf,sBAAsB;AAC1B;;AAEA;IACI,iBAAiB;IACjB,cAAc;IACd,qBAAqB;AACzB;;AAEA;IACI,sBAAsB;AAC1B;;IAEI;QACI,kBAAkB;QAClB,sBAAsB;IAC1B;;IAEA;QACI,kBAAkB;QAClB,gBAAgB;QAChB,qBAAqB;IACzB;;IAEA;QACI,gBAAgB;QAChB,qBAAqB;IACzB;;IAEA;QACI,gCAAgC;QAChC,UAAU;IACd;;IAEA;QACI,sBAAsB;QACtB,gBAAgB;IACpB;;IAEA;QACI,cAAc;QACd,qBAAqB;IACzB;;QAEI;;YAEI,0BAA0B;QAC9B;;AAER;IACI,kBAAkB;IAClB,cAAc;IACd,6BAA6B;IAC7B,iBAAiB;IACjB,kBAAkB;AACtB;;AAEA,sBAAsB;;AAEtB;IACI;QACI,oBAAoB;IACxB;;IAEA;QACI,wBAAwB;QACxB,mBAAmB;IACvB;;IAEA;QACI,iBAAiB;IACrB;AACJ","sourcesContent":["@import '../../../css/App.css';\r\n\r\n.privacy-policy {\r\n    display: flex;\r\n    justify-content: center;\r\n    padding: 2rem 1.5rem;   \r\n}\r\n\r\n.privacy-policy__container {\r\n    max-width: 800px;\r\n    width: 100%;\r\n    background-color: #ffffff;\r\n    border-radius: 12px;\r\n    padding: 2.5rem 2rem;\r\n    box-shadow: 0 8px 24px rgba(0, 0, 0, 0.06);\r\n}\r\n\r\n.privacy-policy__title {\r\n    font-size: 2rem;\r\n    margin-bottom: 0.25rem;\r\n}\r\n\r\n.privacy-policy__last-updated {\r\n    font-size: 0.9rem;\r\n    color: #666666;\r\n    margin-bottom: 1.5rem;\r\n}\r\n\r\n.privacy-policy__section {\r\n    margin-bottom: 1.75rem;\r\n}\r\n\r\n    .privacy-policy__section h2 {\r\n        font-size: 1.25rem;\r\n        margin-bottom: 0.75rem;\r\n    }\r\n\r\n    .privacy-policy__section h3 {\r\n        font-size: 1.05rem;\r\n        margin-top: 1rem;\r\n        margin-bottom: 0.5rem;\r\n    }\r\n\r\n    .privacy-policy__section p {\r\n        line-height: 1.6;\r\n        margin-bottom: 0.5rem;\r\n    }\r\n\r\n    .privacy-policy__section ul {\r\n        margin: 0.5rem 0 0.75rem 1.25rem;\r\n        padding: 0;\r\n    }\r\n\r\n    .privacy-policy__section li {\r\n        margin-bottom: 0.35rem;\r\n        line-height: 1.5;\r\n    }\r\n\r\n    .privacy-policy__section a {\r\n        color: #0b63ce;\r\n        text-decoration: none;\r\n    }\r\n\r\n        .privacy-policy__section a:hover,\r\n        .privacy-policy__section a:focus {\r\n            text-decoration: underline;\r\n        }\r\n\r\n.privacy-policy__disclaimer {\r\n    font-size: 0.85rem;\r\n    color: #777777;\r\n    border-top: 1px solid #eeeeee;\r\n    padding-top: 1rem;\r\n    margin-top: 1.5rem;\r\n}\r\n\r\n/* Responsive tweaks */\r\n\r\n@media (max-width: 600px) {\r\n    .privacy-policy {\r\n        padding: 1.5rem 1rem;\r\n    }\r\n\r\n    .privacy-policy__container {\r\n        padding: 1.75rem 1.25rem;\r\n        border-radius: 10px;\r\n    }\r\n\r\n    .privacy-policy__title {\r\n        font-size: 1.6rem;\r\n    }\r\n}\r\n"],"sourceRoot":""}]);
// Exports
export default ___CSS_LOADER_EXPORT___;
